export const navLinks = [
  { label: "Beliefs", href: "#beliefs" },
  { label: "Products", href: "#products" },
  { label: "How we build", href: "#process" },
  { label: "Partner", href: "#partner" },
];
